import { useBoardSelectionStore } from './boardSelectionStore';
import { useWallContentStore } from './wallContentStore';
import type { BoardElementId } from './boardSelectionStore';
import type { WallCard } from './types';

export function clearLockedElementSelection() {
  const { cards, shapes } = useWallContentStore.getState();
  const lockedElementIds = new Set<BoardElementId>([
    ...getLockedCardIds(cards),
    ...shapes.filter((shape) => shape.isLocked).map((shape) => shape.id),
  ]);

  if (lockedElementIds.size === 0) {
    return;
  }

  useBoardSelectionStore.setState((state) => {
    const selectedIds = state.selectedIds.filter((selectedId) => !lockedElementIds.has(selectedId));
    const currentElement =
      state.currentElement && lockedElementIds.has(state.currentElement.id)
        ? null
        : state.currentElement;

    if (
      selectedIds.length === state.selectedIds.length &&
      currentElement === state.currentElement
    ) {
      return state;
    }

    return {
      currentElement,
      selectedIds,
    };
  });
}

function getLockedCardIds(cards: WallCard[]): BoardElementId[] {
  return cards.flatMap((card) => [
    ...(card.isLocked ? [card.id] : []),
    ...getLockedCardIds(card.cards),
  ]);
}
